import loadable from '@loadable/component';

export const CnSiteWrapper = loadable(
  () => import(/* webpackChunkName: "cn-site" */ './CnSiteWrapper'),
);
